import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ZefFormsModule } from '@zerops/zef/forms';
import { ZuiMaterialFormStackModule } from '@zerops/zui/material-form-stack';
import { ZuiAutofocusModule } from '@zerops/zui/autofocus';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { HttpRoutingFieldsComponent } from './http-routing-fields.component';
import { HttpRoutingFieldsTranslationsModule } from './http-routing-fields.translations';
import { DynamicPopAnchorModule } from '../dynamic-pop-anchor';
import { MatLegacyCardModule as MatCardModule  } from '@angular/material/legacy-card';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZuiDocsTextModule } from '@zerops/zui/docs-text';
import { RoutingLocationItemModule } from '../routing-location-item';

@NgModule({
  declarations: [ HttpRoutingFieldsComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    ZuiDocsTextModule,
    MatButtonToggleModule,
    ZuiAutofocusModule,
    ZuiMaterialFormStackModule,
    FormSectionModule,
    ZuiSeparatorComponent,
    HttpRoutingFieldsTranslationsModule,
    DynamicPopAnchorModule,
    MatCardModule,
    ZefScrollbarComponent,
    ZefDialogModule,
    RoutingLocationItemModule,
    MatTooltipModule
  ],
  exports: [ HttpRoutingFieldsComponent ]
})
export class HttpRoutingFieldsModule {

}
